export default __webpack_public_path__ + "static/media/57_Random_Bottom.00643a96.mp4";